export const template_1 = require('./template_1.png');
export const template_2 = require('./template_2.png');
export const template_3 = require('./template_3.png');
export const template_4 = require('./template_4.png');
export const template_5 = require('./template_5.png');


// WEBPACK FOOTER //
// ./src/assets/flyers/index.js